<template>
  <a-drawer
    width="80%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col
              :md="5"
              :sm="24"
            >
              <a-form-item
                label="设备名称"
                prop="devName"
              >
                <a-input
                  v-model="queryParam.devName"
                  placeholder="请输入设备名称"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="5"
              :sm="24"
            >
              <a-form-item
                label="手机号"
                prop="mobile"
              >
                <a-input
                  v-model="queryParam.mobile"
                  placeholder="请输入手机号"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="5"
              :sm="24"
            >
              <a-form-item
                label="用户名"
                prop="userName"
              >
                <a-input
                  v-model="queryParam.userName"
                  placeholder="请输入用户名"
                  allow-clear
                />
              </a-form-item>
            </a-col>

            <a-col
              :md="5"
              :sm="24"
            >
              <a-form-item
                label="控制器型号"
                prop="controlModel"
              >
                <a-input
                  v-model="queryParam.controlModel"
                  placeholder="请输入控制器型号"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="!advanced && 3 || 24"
              :sm="24"
            >
              <span
                class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
              >
                <a-button
                  type="primary"
                  @click="handleQuery"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['tram:device:add']">
          <a-icon type="plus" />新增
        </a-button> -->
        <!-- <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['tram:device:edit']">
          <a-icon type="edit" />修改
        </a-button> -->
        <a-button
          type="danger"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['tram:device:remove']"
        >
          <a-icon type="delete" />批量解绑
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span
          slot="createTime"
          slot-scope="text, record"
        >
          {{ parseTime(record.createTime) }}
        </span>
        <span
          slot="operation"
          slot-scope="text, record"
        >
          <!-- <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['tram:device:edit']">
            <a-icon type="edit" />修改
          </a> -->
          <a
            @click="handleDelete(record)"
            v-hasPermi="['tram:device:remove']"
            v-if="record.userName"
          >
            解绑
          </a>
          <a
            v-hasPermi="['tram:device:remove']"
            v-if="!record.userName"
          >
            未绑定
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-drawer>
</template>

<script>
import { pageDevice, delDevice } from '@/api/tram/device'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'BindForm',
  props: {
  },
  mixins: [tableMixin],
  components: {
  },
  data () {
    return {
      submitLoading: false,
      open: false,
      formTitle: '',
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        devName: null,
        controlModel: null,
        customerNo: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [

        {
          title: '设备名称',
          dataIndex: 'devName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备编号',
          dataIndex: 'devCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '控制器型号',
          dataIndex: 'controlModel',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '客户编号',
          dataIndex: 'customerNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '绑定用户名',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },

        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
    },
    /** 查询设备信息列表 */
    getList (id) {
      this.loading = true
      this.open = true
      this.queryParam.userId = id
      pageDevice(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.queryParam.userId = this.queryParam.userId
      this.getList(this.queryParam.userId)
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        devName: undefined,
        controlModel: undefined,
        customerNo: undefined,
        pageNum: 1,
        pageSize: 10,
        userId: this.queryParam.userId
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList(this.queryParam.userId)
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.devName || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认解绑所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delDevice(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList(that.queryParam.userId)
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          // 取消清空删除ids列表
          that.ids = []
        }
      })
    }

  }
}
</script>
